module.exports = __webpack_public_path__ + "components/flag/static/square/ar-6e360265f77d2b5165d49b9d91741e50.svg";